import { editorLocalization } from "survey-creator-core";

var persianStrings = {
  "survey": {
    "edit": "ویرایش",
    "externalHelpLink": "نگاه کنید و ساختن نظرسنجی را آموزش ببینید",
    "externalHelpLinkUrl": "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    "dropQuestion": "لطفا از جعبه ابزار سوالی در اینجا قرار دهید",
    "addLogicItem": "برای شخصی سازی نظرسنجی خود، قانونی را ایجاد کنید",
    "copy": "کپی",
    "duplicate": "کپی کردن",
    "settings": "تنظیمات",
    "addToToolbox": "افزودن به جعبه ابزار",
    "deletePanel": "حذف پنل",
    "deleteQuestion": "حذف سوال",
    "convertTo": "تبدیل به",
    "drag": "المان را بکشید",
    "license": "برای استفاده از Survey Creator در برنامه خود باید مجوز توسعه دهنده را خریداری کنید"
  },
  "qt": {
    "default": "پیش فرض",
    "checkbox": "چند انتخابی",
    "comment": "نظر",
    "imagepicker": "انتخاب عکس",
    "ranking": "رتبه بندی(رنک)",
    "image": "عکس",
    "dropdown": "لیست انتخابی",
    "file": "فایل",
    "html": "Html",
    "matrix": "ماتریس (تک انتخابی)",
    "matrixdropdown": "ماتریس (چند انتخابی)",
    "matrixdynamic": "ماتریس (سطرهای داینامیک)",
    "multipletext": "متن چند خطی",
    "panel": "پنل",
    "paneldynamic": "پنل (پنل های داینامیک)",
    "radiogroup": "تک انتخابی",
    "rating": "رتبه بندی",
    "text": "متن تک خطی",
    "boolean": "صحیح و غلط",
    "expression": "توصیفی",
    "signaturepad": "قسمت امضا",
    "buttongroup": "گروه دکمه",
    "flowpanel": "پنل جریان"
  },
  "ed": {
    "defaultLocale": "پیش فرض ({0})",
    "survey": "نظرسنجی",
    "settings": "تنظیمات نظرسنجی",
    "settingsTooltip": "باز کردن تنظیمات نظرسنجی",
    "showPanel": "نمایش پنل",
    "hidePanel": "پنهان سازی پنل",
    "prevSelected": "قبلی",
    "nextSelected": "بعدی",
    "surveyTypeName": "نظرسنجی",
    "pageTypeName": "صفحه",
    "panelTypeName": "پنل",
    "questionTypeName": "سوال",
    "columnTypeName": "ستون",
    "addNewPage": "درج صفحه جدید",
    "moveRight": "اسکرول به راست",
    "moveLeft": "اسکرول به چپ",
    "deletePage": "حذف صفحه",
    "editPage": "ویرایش صفحه",
    "edit": "ویرایش",
    "newPageName": "صفحه",
    "newQuestionName": "سوال",
    "newPanelName": "پنل",
    "newTextItemName": "متن",
    "testSurvey": "آزمایش نظرسنجی",
    "defaultV2Theme": "پیش فرض",
    "modernTheme": "مدرن",
    "defaultTheme": "پیش فرض (legacy)",
    "testSurveyAgain": "آزمایش دوباره نظرسنجی",
    "testSurveyWidth": "عرض نظرسنجی: ",
    "navigateToMsg": "شما باید به موارد زیر بروید:",
    "logic": "منطق نظرسنجی",
    "embedSurvey": "نظرسنجی توکار",
    "translation": "ترجمه",
    "saveSurvey": "ذخیره نظرسنجی",
    "saveSurveyTooltip": "ذخیره نظرسنجی",
    "designer": "طراح نظرسنجی",
    "jsonEditor": "ویرایشگر JSON",
    "jsonHideErrors": "پنهان کردن خطاها",
    "jsonShowErrors": "نمایش خطاها",
    "undo": "بازگردانی",
    "redo": "بازانجام",
    "undoTooltip": "بازگرداندن آخرین تغییر",
    "redoTooltip": "انجام دادن تغییر",
    "showMoreChoices": "نمایش بیشتر",
    "showLessChoices": "نمایش کمتر",
    "copy": "کپی",
    "cut": "برداشتن",
    "paste": "چسباندن",
    "copyTooltip": "کپی متن انتخاب شده در کلیپ بورد",
    "cutTooltip": "متن انتخابی را از کلیپ بورد برش دهید",
    "pasteTooltip": "الصاق از کلیپ بورد",
    "options": "انتخاب ها",
    "generateValidJSON": "تولید کد معتبر JSON",
    "generateReadableJSON": "تولید کد خوانا JSON",
    "toolbox": "جعبه ابزار",
    "property-grid": "ویژگی ها",
    "propertyGridFilteredTextPlaceholder": "جستجو...",
    "toolboxGeneralCategory": "عمومی",
    "correctJSON": "لطفا JSON را تصحیح کنید.",
    "surveyResults": "نتایج نظرسنجی: ",
    "surveyResultsTable": "به صورت جدول",
    "surveyResultsJson": "به صورت JSON",
    "resultsTitle": "عنوان سوال",
    "resultsName": "نام سوال",
    "resultsValue": "محتوای پاسخ",
    "resultsDisplayValue": "محتوای نمایشی",
    "modified": "تغییر داده شده",
    "saving": "در حال ذخیره",
    "saved": "ذخیره شد",
    "propertyEditorError": "ارور:",
    "saveError": "خطا! محتوای ویرایشگر ذخیره نشده است.",
    "translationPropertyGridTitle": "تنظیمات زبان",
    "translationLanguages": "زبان",
    "translationAddLanguage": "زبانی را برای ترجمه انتخاب کنید",
    "translationShowAllStrings": "نمایش تمام عبارات",
    "translationShowUsedStringsOnly": "فقط از عبارات استفاده کنید",
    "translationShowAllPages": "نمایش تمام صفحات",
    "translationNoStrings": "هیچ عبارتی برای ترجمه نیست، لطفا فیلتر را عوض کنید.",
    "translationExportToSCVButton": "برون بری به CSV",
    "translationImportFromSCVButton": "برون ریزی از CSV",
    "translationMergeLocaleWithDefault": "ادغام {0} با زبان پیش فرض",
    "translationPlaceHolder": "در حال ترجمه...",
    "bold": "پررنگ",
    "italic": "مورب",
    "underline": "پایین خط",
    "addNewQuestion": "اضافه کردن سوال",
    "selectPage": "انتخاب صفحه ...",
    "htmlPlaceHolder": "محتوای html اینجا خواهد بود",
    "panelPlaceHolder": "سوالی را از داخل جعبه ابزار در اینجا قرار دهید",
    "surveyPlaceHolder": "نظرسنجی خالی است. یک آیتم را از جعبه ابزار انتخاب یا روی دکمه ی زیر کلیک کنید",
    "addNewTypeQuestion": "اضافه {0}",
    "chooseLogoPlaceholder": "[لوگو]",
    "lg": {
      "addNewItem": "اضافه کردن آیتم جدید",
      "empty_tab": "یک آیتم را برای سفارشی کردن جریان نظرسنجی انتخاب کنید",
      "page_visibilityName": "قابلیت رویت صفحه ",
      "page_enableName": "فعال/غیرفعال کردن صفحه",
      "panel_visibilityName": "قابلیت رویت پنل",
      "panel_enableName": "فعال/غیرفعال کردن پنل ",
      "question_visibilityName": " قابلیت رویت سوال",
      "question_enableName": "فعال/غیرفعال کردن سوال ",
      "question_requireName": "سوال اختیاری موردنیاز",
      "column_visibilityName": "نمایش/پنهان کردن ستون",
      "column_enableName": "فعال/غیرفعال کردن ستون",
      "column_requireName": "ستون مورد نیاز است",
      "trigger_completeName": "تکمیل نظرسنجی",
      "trigger_setvalueName": "تنظیم عنوان سوال",
      "trigger_copyvalueName": "کپی مقدار سوال",
      "trigger_skipName": "رد کردن سوال ",
      "trigger_runExpressionName": "اجرای متن شفارشی مورد نظر",
      "completedHtmlOnConditionName": "متن سفارشی صفحه 'تشکر' ",
      "page_visibilityDescription": "زمانی که عبارت منطقی مقدار صحیح برمی گرداند صفحه را قابل مشاهده کنید، در غیراینصورت آن را غیرقابل مشاهده نگه دارید.",
      "panel_visibilityDescription": "اگر عبارت منطقی مقدار صحیح بر میگرداند، پنل را فعال کنید، در غیر اینصورت آن را غیرقابل مشاهده نگه دارید.",
      "panel_enableDescription": "یک پنل ایجاد کنید و همه المان های داخل آن را در صورتی که عبارت منطقی مقدار صحیح بر می گرداند را فعال کنید، در غیر اینصورت آن ها را غیرفعال نگه دارید.",
      "question_visibilityDescription": "زمانی که عبارت منطقی مقدار صحیح را برمی گرداند، سوال را قابل مشاهده کنید، در غیر اینصورت آن را غیرمشاهده نگه دارید.",
      "question_enableDescription": "زمانی که عبارت منطقی مقدار صحیح برمی گرداند، سوال را فعال کنید، در غیر اینصورت آن را غیرفعال نگه دارید.",
      "question_requireDescription": "زمانی که عبارت منطقی مقدار صحیح را بر می گرداند، سوال اجبار ی می شود.",
      "trigger_completeDescription": "زمانی که عبارت منطقی مقدار صحیح را بر می گرداند، و بررسی تکمیل می شود،کاربر نهایی صفحه 'تشکر' را مشاهده می کند.",
      "trigger_setvalueDescription": "زمانی که مقدار سوالی که در عبارت منطقی استفاده شده است تغییر می یابد و عبارت منطقی مقدار صحیح را بر می گرداند، آنگاه مقدار برای سوال انتخاب شده تنظیم می شود.",
      "trigger_copyvalueDescription": "زمانی که مقدارهای سوال که در عبارت منطقی استفاده شده اند، تغییر می یابد و عبارت منطقی مقدار صحیح را بر می گرداند، سپس مقدار یکی از سوال های انتخاب شده در سوال دیگر انتخاب شده کپی می شود.",
      "trigger_skipDescription": "زمانی که عبارت منطقی صحیح برمی گرداند، سپس نظرسنجی به سوال انتخابی می رود.",
      "trigger_runExpressionDescription": "اگر عبارت منطقی مقدار صحیح برگرداند، آنگاه عبارت سفارشی اجرا می شود. شما ممکن است به طور اختیاری این نتیجه را به سوال انتخاب شده تبدیل کنید.",
      "completedHtmlOnConditionDescription": " اگر عبارت منطقی مقدار صحیح برگرداند متن صفحه 'تشکر' به متن داده شده تغییر می یابد.",
      "itemExpressionText": "زمانی که عبارت {0} مقدار صحیح بر می گرداند",
      "itemEmptyExpressionText": "قانون جدید",
      "page_visibilityText": "صفحه {0} را قابل مشاهده کنید.",
      "panel_visibilityText": "پنل {0} را قابل مشاهده کنید.",
      "panel_enableText": "فعال کردن پنل {0}",
      "question_visibilityText": "سوال {0} را قابل مشاهده کنید.",
      "question_enableText": "فعال کردن سوال {0}",
      "question_requireText": "ایجاد سوال {0} اجباری",
      "column_visibilityText": "ستون {0} سوال {1} را قابل مشاهده کنید",
      "column_enableText": "ستون {0} سوال {1} را فعال کنید",
      "column_requireText": "ستون {0} سوال {1} را الزامی کنید",
      "trigger_completeText": "بررسی نظرسنجی تمام شد",
      "trigger_setvalueText": "در سوال {0} مقدار {1} را قرار دهید",
      "trigger_copyvalueText": "مقدار سوال {0} را از سوال {1} کپی کنید.",
      "trigger_skipText": "رد کردن نظرسنجی برای سوال {0}",
      "trigger_runExpressionText1": "اجرای عبارت '{0}' ",
      "trigger_runExpressionText2": "و نتیجه آن را داخل سوال {0} ذخیره کنید",
      "completedHtmlOnConditionText": "نمایش متن سفارشی برای صفحه 'تشکر'",
      "showAllQuestions": "تمام سوالات",
      "showAllActionTypes": "همه انواع اقدام",
      "conditions": "شرط(ها)",
      "actions": "عملکرد(ها)",
      "expressionEditorTitle": "عبارت منطقی را تنظیم کنید",
      "actionsEditorTitle": "تعریف کردن عملکرد(ها)",
      "deleteAction": "حذف عملکرد",
      "addNewAction": "اضافه کردن سوال (های) جدید",
      "selectedActionCaption": "یک عملکرد را برای اضافه کردن، انتخاب کنید",
      "expressionInvalid": "عبارت منطقی خالی یا نادرست است. لطفا آن را تضحیح کنید",
      "noActionError": "لطفا حداقل یک عملکرد را اضافه نمایید",
      "actionInvalid": "لطفا مشکلات مربوط به عملکرد(های) خود را برطرف نمایید.",
      "expressionSetup": "تنظیمات عبارت ها",
      "actionsSetup": "تنظیمات عملکردها"
    },
    "opjectPropertiesHeader": "پیشرفته",
    "showObjectProperties": "نمایش مشخصات بخش مورد نظر",
    "hideObjectProperties": "پنهان سازی مشخصات بخش مورد نظر",
    "editSurvey": "ویرایش نظرسنجی",
    "delSelObject": "حذف مورد انتخابی",
    "editSelObject": "ویرایش مورد انتخابی",
    "completedHtmlOnConditionItemText": "نمایش می دهد اگر:"
  },
  "pe": {
    "apply": "اعمال",
    "ok": "تایید",
    "save": "ذخیره",
    "saveTooltip": "ذخیره",
    "cancel": "لغو",
    "reset": "بازنشانی",
    "refresh": "تازه سازی",
    "delete": "حذف",
    "add": "اضافه کردن",
    "addNew": "افزودن",
    "addItem": "برای اضافه کردن یک آیتم کلیک کنید...",
    "addOther": "سایر",
    "addSelectAll": "انتخاب همه",
    "addNone": "هیچکدام",
    "removeAll": "حذف همه",
    "edit": "ویرایش",
    "back": "بازگشت بدون ذخیره",
    "backTooltip": "بازگشت بدون ذخیره",
    "saveAndBack": "ذخیره و بازگشت",
    "saveAndBackTooltip": "ذخیره و بازگشت",
    "editChoices": "ویرایش انتخاب ها",
    "showChoices": "نمایش انتخاب ها",
    "move": "جابجایی",
    "empty": "<خالی>",
    "emptyValue": "مقدار خالی است",
    "fastEntry": "تکمیل سریع",
    "formEntry": "تکمیل فرم",
    "testService": "بررسی سرویس",
    "itemSelectorEmpty": "لطفا یک المان را انتخاب کنید ",
    "conditionActionEmpty": "لطفا عملکرد را انتخاب کنید",
    "conditionSelectQuestion": "انتخاب سوال...",
    "conditionSelectPage": "انتخاب صفحه...",
    "conditionSelectPanel": "انتخاب پنل...",
    "conditionValueQuestionTitle": "لطفا مقدار را انتخاب / وارد کنید",
    "expressionHelp": "لطفا یک عبارت توصیفی را وارد کنید. شما ممکن است از کروشه برای دسترسی به مقدار سوالات استفاده کنید. برای مثال: {question1} = 'value1' or ({question2} = 3 and {question3} < 5)",
    "aceEditorHelp": "برای مشاهده نکات تکمیلی ctrl+space را بفشارید",
    "aceEditorRowTitle": "سطر فعلی",
    "aceEditorPanelTitle": "پنل فعلی",
    "showMore": "برای اطلاعات بیشتر لطفا سند راهنما را مطالعه کنید",
    "assistantTitle": "سوالات موجود:",
    "cellsEmptyRowsColumns": "حداقل باید یک سطر یا ستون وجود داشته باشد.",
    "propertyIsEmpty": "لطفا یک مقدار وارد کنید",
    "propertyIsNoUnique": "لطفاً یک مقدار منحصر به فرد وارد کنید",
    "propertyNameIsNotUnique": "لطفاً یک نام منحصر به فرد وارد کنید",
    "listIsEmpty": "یک آیتم جدید اضافه کنید",
    "expressionIsEmpty": "عبارت خالی است",
    "value": "مقدار",
    "text": "متن",
    "rowid": "شناسه ی سطر",
    "imageLink": "لینک تصویر",
    "columnEdit": "ویرایش ستون: {0}",
    "itemEdit": "ویرایش آیتم: {0}",
    "url": "آدرس وب سایت(url)",
    "path": "آدرس",
    "valueName": "نام مقدار",
    "titleName": "نام عنوان",
    "titlePlaceholder": "عنوان را اینجا وارد کنید",
    "surveyTitlePlaceholder": "عنوان نظرسنجی را اینجا وارد کنید",
    "pageTitlePlaceholder": "عنوان صفحه را اینجا وارد کنید",
    "descriptionPlaceholder": "توضیحات را وارد کنید",
    "surveyDescriptionPlaceholder": "توضیحات نظرسنجی را وارد کنید",
    "pageDescriptionPlaceholder": "توضیحات صفحه را وارد کنید",
    "hasOther": "دارای آیتم دیگر",
    "otherText": "سایر آیتم های متن",
    "hasNone": "هیچ آیتمی ندارد",
    "noneText": "هیچ آیتم متنی وجود ندارد",
    "hasSelectAll": "همه موارد انتخاب شده است",
    "selectAllText": "انتخاب همه آیتم های متن",
    "choicesMin": "حداقل مقدار برای ایجاد خودکار آیتم ها",
    "choicesMax": "حداکثر مقدار برای ایجاد خود آیتم ها",
    "choicesStep": "تفاوت بین موارد تولید شده خودکار",
    "name": "نام",
    "title": "عنوان",
    "cellType": "نوع سلول",
    "colCount": "تعداد ستون",
    "choicesOrder": "ترتیب گزینه را انتخاب کنید",
    "visible": "نمایش داده شود؟",
    "isRequired": "ضروری است؟",
    "isAllRowRequired": "نیاز به پاسخ برای همه سطرها",
    "requiredErrorText": "متن خطای موردنیاز",
    "startWithNewLine": "با سطر جدید شروع شود؟",
    "rows": "تعداد سطر",
    "cols": "تعداد ستون",
    "placeholder": "نگهدارنده متن",
    "showPreview": "پیش نمایش تصویر نشان داده شود؟",
    "storeDataAsText": "ذخیره کردن محتوای فایل در JSON به عنوان متن",
    "maxSize": "حداکثر سایز به بایت",
    "imageHeight": "ارتفاع تصویر",
    "imageWidth": "عرض تصویر",
    "rowCount": "تعداد سطر",
    "columnLayout": "قالب ستون ها",
    "addRowLocation": "اضافه کردن موقعیت دکمه سطری",
    "addRowText": "متن دکمه درج سطر",
    "removeRowText": "متن دکمه حذف سطر",
    "rateMin": "حداقل میزان",
    "rateMax": "حداکثر میزان",
    "rateStep": "میزان مراحل",
    "minRateDescription": "توضیح حداقل امتیاز",
    "maxRateDescription": "توضیح حداکثر امتیاز",
    "inputType": "نوع ورودی",
    "optionsCaption": "نوشته انتخاب ها",
    "defaultValue": "مقدار پیش فرض",
    "cellsDefaultRow": "متن پیش فرض سلول ها",
    "surveyEditorTitle": "ویرایش نظرسنجی",
    "qEditorTitle": "ویرایش سوال: {0}",
    "maxLength": "ماکزیمم طول",
    "buildExpression": "ساختن",
    "editExpression": "ویرایش",
    "and": "و",
    "or": "یا",
    "remove": "حذف",
    "addCondition": "اضافه کردن شرط",
    "showTitle": "نمایش/پنهان کردن عنوان",
    "expandCollapseTitle": "نمایش/پنهان کردن عنوان",
    "locale": "زبان پیش فرض",
    "simulator": "انتخاب دستگاه",
    "landscapeOrientation": "افقی",
    "mode": "حالت (ویرایش/خواندن)",
    "clearInvisibleValues": "پاکسازی مقادیر پنهان",
    "cookieName": "نام کوکی (به منظور جلوگیری از اجرای دوباره نظرسنجی)",
    "sendResultOnPageNext": "ارسال نتایج نظرسنجی در صفحه بعدی",
    "storeOthersAsComment": "ذخیره مقدار 'سایر' در فیلد جداگانه",
    "showPageTitles": "نمایش عنوان صفحات",
    "showPageNumbers": "نمایش شماره صفحات",
    "pagePrevText": "متن دکمه صفحه قبلی",
    "pageNextText": "متن دکمه صفحه بعدی",
    "completeText": "متن دکمه تکمیل نظرسنجی",
    "previewText": "پیش نمایش متن دکمه",
    "editText": "ویرایش متن دکمه",
    "startSurveyText": "متن دکمه شروع نظرسنجی",
    "showNavigationButtons": "نمایش دکمه های ناوبری (ناوبری پیش فرض)",
    "showPrevButton": "نمایش دکمه قبلی (کاربر ممکن است به صفحه قبل برگردد)",
    "firstPageIsStarted": "صفحه اول در نظرسنجی نقطه آغازین آن است.",
    "showCompletedPage": "نمایش صفحه اتمام نظرسنجی در پایان (completedHtml)",
    "goNextPageAutomatic": "با پاسخگویی به تمام سوالات، به صورت اتوماتیک به صفحه بعد برود",
    "showProgressBar": "نمایش نشانگر پیشرفت",
    "questionTitleLocation": "محل عنوان سوال",
    "requiredText": "سوالات نشان دار اجباری هستند",
    "questionStartIndex": "نمایه شروع سوالات (۱،۲ یا a و b)",
    "showQuestionNumbers": "نمایش شماره های سوالات",
    "questionTitleTemplate": "قالب عنوان سوال، به صورت پیش فرض: '{no}. {require} {title}'",
    "questionErrorLocation": "محل خطای سوال",
    "focusFirstQuestionAutomatic": "تمرکز بر روی اولین سوال با تغییر صفحه",
    "questionsOrder": "ترتیب المان ها در صفحه",
    "maxTimeToFinish": "نهایت زمان برای اتمام نظرسنجی",
    "maxTimeToFinishPage": "نهایت زمان برای اتمام این صفحه نظرسنجی",
    "showTimerPanel": "نمایش پنل زمان سنج",
    "showTimerPanelMode": "نمایش حالت پنل زمان سنج",
    "renderMode": "حالت رندر",
    "allowAddPanel": "اجازه افزودن پنل",
    "allowRemovePanel": "اجازه حذف پنل",
    "panelAddText": "متن افزودن پنل",
    "panelRemoveText": "متن حذف پنل",
    "isSinglePage": "نمایش تمام المان ها در یک صفحه",
    "html": "Html",
    "expression": "عبارت",
    "minValue": "حداقل مقدار",
    "maxValue": "حداکثر مقدار",
    "minLength": "حداقل طول",
    "allowDigits": "امکان ورود اعداد",
    "minCount": "حداقل تعداد ",
    "maxCount": "حداکثر مقدار",
    "regex": "فرمت صحیح عبارت ",
    "totalText": "متن کامل",
    "totalType": "نوع کامل",
    "totalExpression": "عبارت کامل",
    "totalDisplayStyle": "سبک نمایش کل",
    "totalCurrency": "مجموع ارز",
    "totalFormat": "مجموع فرمت",
    "logoPosition": "محل قرارگیری لوگو",
    "addLogo": "اضافه کردن لوگو...",
    "changeLogo": "تغییر لوگو...",
    "logoPositions": {
      "none": "حذف لوگو",
      "left": "چپ",
      "right": "راست",
      "top": "بخش بالا",
      "bottom": "بخش پایین"
    },
    "tabs": {
      "general": "عمومی",
      "fileOptions": "انتخاب ها",
      "html": "ویرایشگر HTML",
      "columns": "ستون ها",
      "rows": "سطرها",
      "choices": "انتخاب ها",
      "items": "آیتم ها",
      "visibleIf": "نمایش در صورت",
      "enableIf": "فعال اگر",
      "requiredIf": "مورد نیاز ااگر",
      "rateValues": "مقادیر رتبه بندی",
      "choicesByUrl": "انتخاب ها از وب",
      "matrixChoices": "انتخاب های پیشفرض",
      "multipleTextItems": "فیلدهای متنی",
      "numbering": "شماره گذاری",
      "validators": "اعتبارسنجی ها",
      "navigation": "ناوبری",
      "question": "سوال",
      "pages": "صفحات",
      "completedHtml": "HTML صفحه تکمیل نظرسنجی",
      "completedHtmlOnCondition": "Html در شرط کامل شد",
      "loadingHtml": "HTML بارگزاری",
      "timer": "زمان سنج/کوئیز",
      "calculatedValues": "مقادیر محاسبه شد",
      "triggers": "اجرا کننده",
      "templateTitle": "عنوان قالب",
      "totals": "جمع کل",
      "logic": "منطق",
      "layout": "چیدمان",
      "data": "اطلاعات",
      "validation": "اعتبارسنجی",
      "cells": "سلول ها",
      "showOnCompleted": "نمایش بدهید تکمیل شده",
      "logo": "لوگو در عنوان نظرسنجی",
      "slider": "اسلایدر",
      "others": "باقی موارد"
    },
    "editProperty": "ویرایش خصوصیت '{0}'",
    "items": "[ آیتم ها: {0} ]",
    "enterNewValue": "لطفا یک مقدار وارد کنید",
    "noquestions": "سوالی در پرسشنامه درج نشده",
    "createtrigger": "اجرا کننده ای بسازید",
    "titleKeyboardAdornerTip": "برای ویرایش دکمه ی enter را فشار دهید.",
    "keyboardAdornerTip": "برای ویرایش دکمه ی enter را فشار دهید, برای حذف دکمه ی delete را فشار دهید, برای حرکت دادن یک آیتم، دکمه ی  alt + arrow down /  alt + arrow up فشار دهید",
    "keyboardMoveItemsTip": "برای حرکت دادن یک آیتم، دکمه ی  alt + arrow down /  alt + arrow up فشار دهید",
    "triggerOn": "در ",
    "triggerMakePagesVisible": "صفحات را قابل نمایش کن:",
    "triggerMakeQuestionsVisible": "سوالات را قابل نمایش کن:",
    "triggerCompleteText": "پرسشنامه را تکمیل کن اگر موفق بود.",
    "triggerNotSet": "اجرا کننده تنظیم نشده.",
    "triggerRunIf": "اجرا در صورت",
    "triggerSetToName": "تعییر مقدار از: ",
    "triggerFromName": "کپی مقدار از: ",
    "triggerRunExpression": "اجرای این عبارت",
    "triggerSetValue": "به: ",
    "triggerGotoName": "به سوال بروید:",
    "triggerIsVariable": "عدم درج متغییر در نتایج پرسشنامه",
    "triggerRunExpressionEmpty": "لطفا عبارت معتبری وارد نمایید",
    "noFile": "هیچ فایلی انتخاب نشده است",
    "close": "بستن",
    "itemValueEdit": "قابل مشاهده اگر",
    "notEmpty": "<ویرایش مقدار>",
    "conditionButtonAdd": "اضافه",
    "conditionButtonReplace": "جایگزین",
    "conditionHelp": "لطفا یک مقدار بولین توصیفی وارد کنید که صحیح یا غلط را برگرداند تا صفحه سوالات نمایش داده شود. برای مثال: {question1} = 'value1' or ({question2} * {question4}  > 20 and {question3} < 5)",
    "conditionShowMoreUrl": "https://surveyjs.io/Documentation/LibraryParameter?id=Question&parameter=visibleIf"
  },
  "pv": {
    "true": "صحیح",
    "false": "غلط",
    "inherit": "ارث بری",
    "show": "آشکار",
    "hide": "پنهان",
    "default": "پیش فرض",
    "initial": "اولیه",
    "random": "تصادفی",
    "collapsed": "جمع شده",
    "expanded": "باز شده",
    "none": "هیچ کدام",
    "asc": "صعودی",
    "desc": "نزولی",
    "indeterminate": "نامشخص",
    "decimal": "اعشاری",
    "currency": "ارز",
    "percent": "درصد",
    "firstExpanded": "گسترش یافته",
    "off": "خاموش",
    "onPanel": "روی پنل",
    "onSurvey": "روی نظرسنجی",
    "list": "لیست",
    "progressTop": "نوار پیشرفت  بالا",
    "progressBottom": "نوار پیشرفت پایین",
    "progressTopBottom": "نوار پیشرفت در بالا و پایین",
    "horizontal": "افقی",
    "vertical": "عمودی",
    "top": "بالا",
    "bottom": "پایین",
    "topBottom": "بالا و پایین",
    "both": "هر دو",
    "left": "چپ",
    "color": "رنگ",
    "date": "تاریخ",
    "datetime": "تاریخ و ساعت",
    "datetime-local": "تاریخ و سوال پیش فرض",
    "email": "ایمیل",
    "month": "ماه",
    "number": "عدد",
    "password": "رمزعبور",
    "range": "دامنه",
    "tel": "تلفن",
    "text": "متن",
    "time": "زمان",
    "url": "آدرس",
    "week": "هفته",
    "hidden": "مخفی",
    "on": "روشن",
    "onPage": "روی صفحه",
    "edit": "ویرایش",
    "display": "نمایش",
    "onComplete": "به محض تمام شدن",
    "onHidden": "به محض مخفی شدن",
    "all": "تمام",
    "page": "صفحه",
    "survey": "نظرسنجی",
    "onNextPage": "به محض صفحه بعدی",
    "onValueChanged": "به محض تغییر مقدار",
    "singlePage": "تک صفحه ای",
    "standard": "استاندارد",
    "questionPerPage": "سوال در هر صفحه ی مجزا",
    "noPreview": "پیش نمایش ندارد",
    "showAllQuestions": "فعال سازی پیش نمایش با تمام سوالات",
    "showAnsweredQuestions": "فعال سازی پیش نمایش به سوالات پاسخ داده شده"
  },
  "op": {
    "empty": "خالی باشد",
    "notempty": "خالی نباشد",
    "equal": "مساوی باشد",
    "notequal": "مساوی نباشد",
    "contains": "شامل",
    "notcontains": "شامل نباشد",
    "anyof": "هرکدام",
    "allof": "همه",
    "greater": "بزرگتر",
    "less": "کوچکتر",
    "greaterorequal": "بزرگتر یا مساوی",
    "lessorequal": "کوچکتر یا مساوی",
    "and": "و",
    "or": "یا"
  },
  "ew": {
    "angular": "استفاده از نسخه Angular",
    "jquery": "استفاده از نسخه jQuery",
    "knockout": "استفاده از نسخه ناک اوت",
    "react": "استفاده از نسخه React",
    "vue": "استفاده از نسخه Vue",
    "bootstrap": "برای فریم ورک بوتسترپ",
    "modern": "تم مدرن",
    "default": "تم پیش فرض",
    "orange": "تم نارنجی",
    "darkblue": "تم آبی تیره",
    "darkrose": "تم صورتی",
    "stone": "تم سنگی",
    "winter": "تم زمستانی",
    "winterstone": "تم زمستانی و سنگی",
    "showOnPage": "نمایش نظرسنجی در یک صفحه",
    "showInWindow": "نمایش نظرسنجی در یک پنجره",
    "loadFromServer": "بارگزاری JSON از سرور",
    "titleScript": "اسکریپت و شیوه نمایش",
    "titleHtml": "HTML",
    "titleJavaScript": "جاوااسکریپت",
    "standard": "بدون بوتسترپ"
  },
  "ts": {
    "selectPage": "صفحه ای را برای آزمایش انتخاب کنید:",
    "showInvisibleElements": "نمایش المان های مخفی"
  },
  "validators": {
    "answercountvalidator": "تعداد پاسخ",
    "emailvalidator": "ایمیل",
    "expressionvalidator": "عبارت",
    "numericvalidator": "عدد",
    "regexvalidator": "regex",
    "textvalidator": "متن"
  },
  "triggers": {
    "completetrigger": "تکمیل نظرسنجی",
    "setvaluetrigger": "تنظیم مقدار",
    "copyvaluetrigger": "کپی مقدار",
    "skiptrigger": "رد کردن سوال ",
    "runexpressiontrigger": "اجرای عبارت",
    "visibletrigger": "تغییر وضعیت دیده شدن"
  },
  "pehelp": {},
  "p": {
    "name": "نام",
    "title": {
      "name": "عنوان",
      "title": "اگر خالی باشد مانند نام درج می شود"
    },
    "navigationButtonsVisibility": "پدیداری دکمه های ناوبری",
    "questionsOrder": "ترتیب سوالات",
    "maxTimeToFinish": "حداکثر زمان برای تکمیل",
    "visible": "آشکار",
    "visibleIf": "آشکار اگر",
    "questionTitleLocation": "موقعیت عنوان سوال",
    "description": "توضیحات",
    "state": "وضعیت",
    "isRequired": "اجباری؟",
    "requiredIf": "اجبار اگر؟",
    "indent": "indent",
    "requiredErrorText": "متن خطای اجباری",
    "startWithNewLine": "شروع با خط جدید ",
    "innerIndent": "تو رفتگی داخلی",
    "page": "صفحه",
    "width": "عرض",
    "commentText": "متن نظر",
    "valueName": "نام مقدار",
    "enableIf": "فعال اگر",
    "defaultValue": "مقدار پیش فرض",
    "correctAnswer": "پاسخ صحیح",
    "readOnly": "فقط خوانش",
    "validators": "اعتبارسنج ها",
    "titleLocation": "محل قرارگیری عنوان",
    "hasComment": "نظر دارد؟",
    "hasOther": "سایر دارد؟",
    "choices": "گزینه ها",
    "choicesOrder": "ترتیب گزینه ها",
    "choicesByUrl": "گزینه ها با لینک",
    "otherText": "متن سایر",
    "otherErrorText": "متن خطای سایر",
    "storeOthersAsComment": "ذخیره سایر به صورت نظر",
    "label": "برچسب",
    "showTitle": "نامیش عنوان",
    "valueTrue": "مقادیر صحیح",
    "valueFalse": "مقادیر غلط",
    "cols": "ستون ها",
    "rows": "سطر ها",
    "placeholder": "محل نگهدارنده",
    "optionsCaption": "زیرنویس گزینه ها",
    "expression": "عبارت",
    "format": "فرمت",
    "displayStyle": "سبک نمایش",
    "currency": "ارز",
    "useGrouping": "استفاده از گروه بندی",
    "showPreview": "پیش نمایش",
    "allowMultiple": "اجازه چند انتخابی",
    "imageHeight": "طول عکس",
    "imageWidth": "عرض عکس",
    "storeDataAsText": "ذخیره داده به صورت متنی",
    "maxSize": "نهایت حجم",
    "html": "html",
    "columns": "ستون ها",
    "cells": "سلول ها",
    "isAllRowRequired": "آیا تمام سطرها اجباری اند؟",
    "horizontalScroll": "اسکرول افقی",
    "cellType": "نوع سلول",
    "columnsLayout": "طرح بندی ستون ها",
    "columnColCount": "تعداد ستون ها",
    "columnMinWidth": "حداقل عرض ستون",
    "rowCount": "تعداد سطر",
    "minRowCount": "حداقل تعداد سطر",
    "maxRowCount": "حداکثر تعداد سطر",
    "keyName": "کلید نام",
    "keyDuplicationError": "کلید ارور کپی ",
    "confirmDelete": "تاییدیه حذف",
    "confirmDeleteText": "متن تاییدیه حذف",
    "addRowLocation": "اضافه کردن موقعیت سطر",
    "addRowText": "افزودن متن سطر",
    "removeRowText": "حذف متن سطر",
    "items": "موارد",
    "itemSize": "ابعاد مورد",
    "colCount": "تعداد ستون",
    "templateTitle": "عنوان الگو",
    "templateDescription": "شرح الگو",
    "allowAddPanel": "اضافه کردن پنل مجاز است",
    "allowRemovePanel": "حذف کردن پنل مجاز است",
    "panelCount": "تعداد پنل",
    "minPanelCount": "حداقل تعداد پنل",
    "maxPanelCount": "حداکثر تعداد پنل",
    "panelsState": "شرح دادن پنل ها",
    "panelAddText": "اضافه کردن متن به پنل ها",
    "panelRemoveText": "حذف کردن متن پنل ها",
    "panelPrevText": "متن قبلی پنل",
    "panelNextText": "متن بعدی پنل",
    "showQuestionNumbers": "نمایش تعداد سوالات",
    "showRangeInProgress": "دامنه مورد نظر در حال انجام است.",
    "renderMode": "حالت رندر",
    "templateTitleLocation": "عنوان مکان",
    "rateValues": "رتبه بندی مقادیر",
    "rateMin": "حداقل رتبه",
    "rateMax": "حداکثر رتبه",
    "rateStep": "مراحل رتبه بندی",
    "minRateDescription": "مشخصات حداقل رتبه بندی",
    "maxRateDescription": "مشخصات حداکثر رتبه بندی",
    "inputType": "نوع ورودی",
    "size": "حجم",
    "locale": "زبان",
    "focusFirstQuestionAutomatic": "پیش فرض سوال اول انتخاب شده باشد.",
    "completedHtml": "html کامل شده",
    "completedBeforeHtml": "قبل از html  کامل شده",
    "loadingHtml": "بارگذاری Html",
    "triggers": "فعال سازی",
    "cookieName": "نام کوکی",
    "sendResultOnPageNext": "ارسال نتیجه در صفحه بعدی",
    "showNavigationButtons": "نمایش دکمه های جهت یابی",
    "showPrevButton": "نمایش دکمه ی قبلی",
    "showPageTitles": "نمایش عنوان صفحه",
    "showCompletedPage": "نمایش صفحه ی کامل",
    "showPageNumbers": "نمایش شماره ی صفحات",
    "questionErrorLocation": "موقعیت قرارگیری خطای سوالات",
    "showProgressBar": "نمایش نوار پیشرفت",
    "mode": "حالت",
    "goNextPageAutomatic": "اتوماتیک به صفحه ی بعدی برود",
    "checkErrorsMode": "حالت خطاها را بررسی کنید",
    "clearInvisibleValues": "مقادیر نامعلوم را پاک کنید",
    "startSurveyText": "شروع متن نظرسنجی",
    "pagePrevText": "متن صفحه ی قبلی",
    "pageNextText": "متن صفحه ی بعدی",
    "completeText": "متن کامل",
    "requiredText": "متن اجباری",
    "questionStartIndex": "فهرست شروع سوالات",
    "questionTitleTemplate": "الگوی موضوعات سوالات",
    "firstPageIsStarted": "صفحه اول شروع می شود",
    "isSinglePage": "آیا تک صفحه ای است؟",
    "maxTimeToFinishPage": "حداکثر زمان برای به پایان رساندن  صفحه",
    "showTimerPanel": "نمایش پنل زمان بندی",
    "showTimerPanelMode": "نمایش حالت پنل زمان بندی",
    "defaultPanelValue": "مقدار پیش فرض  پنل",
    "defaultRowValue": "مقدار پیش فرض سطر",
    "hasNone": "موردی ندارد",
    "noneText": "متنی ندارد",
    "text": "متن",
    "survey_title": {
      "name": "عنوان",
      "title": "در تمام صفحات دیده می شود"
    },
    "page_title": {
      "name": "عنوان",
      "title": "عنوان صفحه"
    },
    "minValue": "حداقل مقدار",
    "maxValue": "حداکثر مقدار",
    "minLength": "حداقل طول",
    "maxLength": "حداکثر طول",
    "allowDigits": "اجازه عدد",
    "minCount": "حداقل تعداد",
    "maxCount": "حداکثر تعداد",
    "regex": "عبارت با قاعده"
  },
  "pel": {
    "isRequired": "اجباری؟"
  }
};

editorLocalization.locales["fa"] = persianStrings;
